import '../App.css';

function AboutText() {
    return (
        <div class="time-left-wrapper">
       
Welcome to beautiful Ojai, California. Home of the Pink Moment.
<br/><br/>
In the final ten minutes before sunset, the mountains begin to glow with a deepening orange hue that intensifies steadily until the sun dips below the horizon. While this golden display is undeniably gorgeous, it's merely a prelude to the true spectacle that emerges in the following 5-8 minutes: the Pink Moment, a breathtaking phenomenon that bathes the landscape in rosy light but lasts only about a minute and a half before fading away.
<br/><br/>

Pro tip:  Lower humidity will mean more spectacular pinks.
<br/><br/>

Ojai lies in a rare east/west valley. Most mountain ranges run on a north/south axis which means that most valleys run north and south. Our valley catches the late western sun rather than blocking it out.
<br/><br/>
            
As the sun starts to set over the Pacific Ocean, its light travels a long way through the atmosphere and refracts into marvelous colors upon the Topatopa Bluffs that tower over the Ojai Valley. The naturally reddish rocky faces of these bluffs create a perfect canvas for light that is refracted and possibly also reflected by the ocean. For a few fleeting moments the Topatopa mountains illuminate with glorious shades of pink along with bands of orange and red.
<br/><br/>

While the sun does set daily, the Pink Moment is not always visible due to clouds, precipitation, or other impediments that block the sun's light from reaching our 6,000+ foot mountains.
<br/><br/>

If you have a photo of the PinkMoment that you'd like to share, please tag us on Instagram @ojaipinkmoment.
    </div>
  );
}

export default AboutText;
